export default __webpack_public_path__ + "static/media/block.26301c50.png";